const MuiAccordion = {
  defaultProps: {
    disableGutters: true,
    square: true,
  },
  styleOverrides: {
    root: {
      '&::before': { display: 'none' },
      marginTop: 1,
    },
  },
};

const MuiAccordionSummary = {
  styleOverrides: {
    root: {
      minHeight: 42,
      padding: '0 10px',
    },
    content: {
      margin: '8px 0',
    },
  },
};

const MuiAccordionDetails = {
  styleOverrides: {
    root: {
      padding: '10px 0',
    },
  },
};

export { MuiAccordion, MuiAccordionSummary, MuiAccordionDetails };
